// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bah1h6o{justify-content:center}
._1bsb1osq{width:100%}
._1e0c1txw{display:flex}
._1t3b1wug >div{flex-basis:auto}
._4cvr1h6o{align-items:center}
._4t3i1w81{height:150px}
._nphsidpf >div{flex-grow:0}
._t1edidpf >div{flex-shrink:0}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/emoji/dist/esm/components/picker/EmojiPickerVirtualItems.compiled.css"],"names":[],"mappings":"AAAA,WAAW,sBAAsB;AACjC,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,gBAAgB,eAAe;AAC/B,WAAW,kBAAkB;AAC7B,WAAW,YAAY;AACvB,gBAAgB,WAAW;AAC3B,gBAAgB,aAAa","sourcesContent":["._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1t3b1wug >div{flex-basis:auto}\n._4cvr1h6o{align-items:center}\n._4t3i1w81{height:150px}\n._nphsidpf >div{flex-grow:0}\n._t1edidpf >div{flex-shrink:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
